module.exports = __webpack_public_path__ + "img/corsica.11859084.svg";